const zhCN = {
  'modal.close': '关闭',
  'session_expired.title': '会话已过期',
  'tokenizationForm.payment-terms.text1': '我授权飞汇代表“{{recipientName}}”自动存储我的借记卡/信用卡信息并在我的借记卡/信用卡中自动扣款。我已阅读、理解并同意遵守',
  'tokenizationForm.general-terms.link2': '隐私政策',
  'tokenizationForm.general-terms.link-joint': ' 和 ',
  'tokenizationForm.general-terms.link1': '使用条款',
  'tokenizationForm.payment-terms.link': '飞汇的自动付款使用条款',
  'tokenizationForm.labels.cvvTooltip': '卡背面的 3 位数字或正面的 4 位数字',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': '到期日 (MM/YY)',
  'tokenizationForm.labels.cardNumber': '卡号',
  'tokenizationForm.labels.phone': '电话号码',
  'tokenizationForm.labels.upopPhone': '请输入与此银行卡关联的手机号码',
  'tokenizationForm.labels.zip': '邮政编码',
  'tokenizationForm.labels.address': '地址',
  'cardsForm.labels.state': '状态',
  'tokenizationForm.labels.country': '国家/地区',
  'tokenizationForm.labels.city': '城市',
  'tokenizationForm.labels.email': '电子邮件',
  'tokenizationForm.labels.lastName': '姓',
  'tokenizationForm.labels.firstName': '名',
  'cardsForm.title': '持卡人信息',
  'success.title': '款项在途',
  'success.title.info': '资金到账需要 2-3 个工作日。\n到账后，您会收到一封电子邮件。',
  'bankAccountForm.hints.generic': '例如：{{label}}',
  'bankAccountForm.hints.account_number': '银行账号长度必须介于 1 到 17 个字符之间',
  'bankAccountForm.hints.routing_number': '收款行清算号长度必须为 9 位数字',
  'bankAccountForm.labels.accountZipCode': '邮政编码',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'BIC 代码',
  'bankAccountForm.labels.accountNumber': '银行账号',
  'bankAccountForm.labels.accountSortCode': '清算代码',
  'bankAccountForm.labels.accountRoutingNumber': '收款行清算号',
  'bankAccountForm.labels.accountType': '账户类型',
  'bankAccountForm.labels.eftProviderWidnow': '您将跳转到我们合作伙伴的处理平台完成此付款。完成之后，您会再次回到本页面',
  'bankAccountForm.labels.termsFlywire': '我已阅读、理解并同意飞汇<a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/terms/\' target=\'_blank\' rel=\'noopener noreferrer\' data-testid=\'termsOfUseLink\'>使用条款</a>和<a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/privacy/\' target=\'_blank\' data-testid=\'privacyPolicyLink\' rel=\'noopener noreferrer\'>隐私政策</a>',
  'bankAccountForm.labels.termsDirectDebit': '我确认，本人是此账户的所有者并且是授权此贷记/借记所需的唯一签字人',
  'bankAccountForm.labels.termsEft': '我已阅读、理解并同意<a class=\'fw-underline fw-text-primary-600\' href=\'https://opu.myonplanu.com/pdf/pad-agreement.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>预授权借记协议</a>',
  'bankAccountForm.labels.city': '城市',
  'bankAccountForm.labels.country': '国家/地区',
  'bankAccountForm.labels.selectCountry': '选择国家或地区',
  'bankAccountForm.title': '账户持有人信息',
  'failure.tryAgain': '重试',
  'failure.title': '交易失败',
  'failure.connectivity.message': '操作失败，这可能是由于某些连接问题导致的。',
  'failure.message': '交易失败。这可能是由于连接问题。请重试。如果问题仍然存在，请尝试其他支付方式或联系您的银行',
  'sessionExpired.text': '会话已过期',
  'LoadingError.title': '出现了错误',
  'LoadingError.message': '加载表单时出错',
  'tokenizationForm.errors.noPaymentOptionsAvailable': '所选国家/地区没有可用的付款方式',
  'offerError.noOptions.card': 'The selected card type is not supported. Please use a different card type.',
  'offerError.noOptions.bank': 'The selected bank account is not supported. Please use a different bank account.',
  'offerError.noOptions.other': 'The selected Payment Method is not supported. Please use a different Payment Method.',
  'bankAccountForm.labels.accountHolderType.personal': '个人账户',
  'bankAccountForm.labels.accountHolderType.business': '企业账户',
  'bankAccountForm.labels.name': '名',
  'bankAccountForm.labels.businessName': '企业名称',
  'bankAccountForm.labels.surname': '姓',
  'bankAccountForm.labels.phone': '电话号码',
  'bankAccountForm.labels.email': '邮箱',
  'bankAccountForm.labels.zip': '邮政编码',
  'bankAccountForm.labels.accountAddress': '地址',
  'bankAccountForm.labels.address': '地址',
  'bankAccountForm.errors.dynamicFields': '无效的 {{field}}',
  'bankAccountForm.labels.saveButton': '保存',
  'bankAccountForm.labels.nextButton': '下一步',
  'bankAccountForm.labels.payButton': '支付',
  'bankAccountForm.errors.cardNumber': '卡号无效',
  'tokenizationForm.errors.cardNumber': '卡号无效',
  'tokenizationForm.errors.cvv': 'CVV 号码无效',
  'bankAccountForm.errors.cvv': 'CVV 号码无效',
  'tokenizationForm.errors.unsupportedCardTypes': '仅支持{{acceptedCardsList}}',
  'tokenizationForm.errors.unsupportedCardType': '仅支持 {{acceptedCard}}',
  'tokenizationForm.errors.cardType.and': '和',
  'tokenizationForm.errors.name': '名无效',
  'tokenizationForm.errors.email': '电子邮件无效',
  'tokenizationForm.errors.country': '无效的国家或地区',
  'tokenizationForm.errors.state': '无效的省/直辖市/自治区',
  'tokenizationForm.errors.city': '城市无效',
  'tokenizationForm.errors.address': '地址无效',
  'tokenizationForm.errors.addressIsPoBox': '地址栏中不能填写邮政信箱。',
  'tokenizationForm.errors.onlyLetterOrNumbers': '有效字符仅包括 A-Z 和 0-9',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol': '有效字符仅包括 A-Z、0-9 以及 / 和 -',
  'tokenizationForm.errors.zip': '无效的邮编',
  'tokenizationForm.errors.expiryDate': '到期日无效',
  'bankAccountForm.errors.expiryDate': '到期日无效',
  'tokenizationForm.errors.surname': '姓氏无效',
  'tokenizationForm.errors.phone': '电话号码无效',
  'tokenizationForm.errors.length': '字段太长（最多 256 个字符）',
  'tokenizationForm.errors.required.field': '必填项目',
  'bankAccountForm.errors.name': '名无效',
  'bankAccountForm.errors.name.maxSizeExceeded': '名字太长（最多 140 个字符）',
  'form.errors.name.maxSizeExceeded': '名字太长（最多 {{limit}} 个字符）',
  'form.errors.surname.maxSizeExceeded': '姓氏太长（最多 {{limit}} 个字符）',
  'form.errors.business_name.maxSizeExceeded': '企业名称太长（最多 {{limit}} 个字符）',
  'form.errors.city.maxSizeExceeded': '城市太长（最多 {{limit}} 个字符）',
  'form.errors.address.maxSizeExceeded': '地址太长（最多 {{limit}} 个字符）',
  'form.errors.date.wrongDate': '日期选择器值无效',
  'bankAccountForm.errors.business_name': '企业名称无效',
  'bankAccountForm.errors.business_name.maxSizeExceeded': '企业名称太长（最多 140 个字符）',
  'bankAccountForm.errors.surname': '姓无效',
  'bankAccountForm.errors.surname.maxSizeExceeded': '姓氏太长（最多 140 个字符）',
  'bankAccountForm.errors.country': '无效的国家或地区',
  'bankAccountForm.errors.address': '地址无效',
  'bankAccountForm.errors.address.maxSizeExceeded': '地址太长（最多 256 个字符）',
  'bankAccountForm.errors.city': '城市无效',
  'bankAccountForm.errors.city.maxSizeExceeded': '城市太长（最多 256 个字符）',
  'bankAccountForm.errors.email': '电子邮件无效',
  'bankAccountForm.errors.state': '无效的省/直辖市/自治区',
  'bankAccountForm.errors.iban': 'IBAN 无效',
  'bankAccountForm.errors.bic': 'BIC 代码无效',
  'bankAccountForm.errors.accountnumber': '银行账号无效',
  'bankAccountForm.errors.sortcode': '清算代码无效',
  'bankAccountForm.errors.account_type': '账户类型无效',
  'bankAccountForm.errors.addressIsPoBox': '地址栏中不能填写邮政信箱。',
  'bankAccountForm.errors.onlyLetterOrNumbers': '有效字符仅包括 A-Z 和 0-9',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': '有效字符包括：A-Z 0-9 / ， -',
  'bankAccountForm.errors.zip': '邮政编码无效',
  'bankAccountForm.errors.phone': '电话号码无效',
  'bankAccountForm.errors.ach_account_number': '银行账号无效',
  'bankAccountForm.errors.routing_number': '收款行清算号无效',
  'bankAccountForm.errors.offer': '没有可用的付款方式 - 如果您在其他国家/地区拥有银行账户，请选择该国家/地区或选择其他卡并重试。如果仍然无法解决此问题，请联系 {{recipientName}}',
  'binLookUp.unableToFindCard.message': '卡错误。请核对您输入的卡详细信息或尝试其他卡。',
  'binLookUp.warning.message': '我们无法验证您的卡',
  'confirmationPage.labels.edit': '编辑',
  'confirmationPage.labels.confirm': '确认',
  'confirmationPage.labels.title': '检查必填信息',
  'confirmationPage.labels.typeOfPayment': '付款类型',
  'confirmationPage.labels.paymentRecipient': '收款人',
  'confirmationPage.labels.typeOfPayment.oneOff': '一次性',
  'confirmationPage.labels.typeOfPayment.recurring': '经常性',
  'confirmationPage.labels.directDebitInformation': '直接扣款信息',
  'confirmationPage.labels.directDebitInformation.title': '关于银行的说明',
  'confirmationPage.labels.directDebitInformation.creditor': '收款人',
  'confirmationPage.labels.directDebitInformation.creditorId': '收款人 ID',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': '对账单中的姓名',
  'confirmationPage.labels.directDebitInformation.serviceUserId': '服务用户 ID',
  'confirmationPage.labels.directDebitInformation.address': '飞汇地址',
  'confirmationPage.labels.directDebitInformation.originator': 'Originator',
  'confirmationPage.labels.directDebitInformation.originatorId': 'Originator ID',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Originator 地址',
  'confirmationPage.labels.bankAccountInformation': '银行账户信息',
  'confirmationPage.labels.bankAccountInformation.name': '姓名',
  'confirmationPage.labels.bankAccountInformation.iban': 'IBAN 编号',
  'confirmationPage.labels.bankAccountInformation.email': '邮箱',
  'confirmationPage.labels.bankAccountInformation.country': '国家/地区',
  'confirmationPage.labels.bankAccountInformation.state': '状态',
  'confirmationPage.labels.bankAccountInformation.city': '城市',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'BIC 代码',
  'confirmationPage.labels.bankAccountInformation.accountNumber': '银行账号',
  'confirmationPage.labels.bankAccountInformation.sortCode': '清算代码',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': '银行账号',
  'confirmationPage.labels.bankAccountInformation.routingNumber': '收款行清算号',
  'confirmationPage.labels.bankAccountInformation.accountType': '账户类型',
  'confirmationPage.labels.paymentInformation': '付款信息',
  'confirmationPage.labels.paymentInformation.amount': '金额',
  'confirmationPage.labels.changeAccountEft': '更改银行账户详细信息',
  'confirmationPage.labels.editPayerEft': '编辑付款人详细信息',
  'confirmationPage.labels.useAccountEft': '使用以 **** {{lastFour}} 结尾的账户',
  'confirmationPage.labels.bankLinkSuccessMessage': '银行账户已成功关联',
  'confirmationPage.labels.termsSepa': '签署此授权书即表示，您授权 (A) FLYWIRE EUROPE UAB 向您的银行发送扣款说明，并授权 (B) 您的银行根据 FLYWIRE EUROPE UAB 的说明从您的账户扣款。您会在扣款前至少 3 天获得通知。',
  'confirmationPage.labels.termsBacs': '指示您的银行从本说明所列账户直接扣款，用以支付飞汇付款专用直接扣款的费用，但须遵守直接扣款担保的保障措施。我了解，此说明可能由 Flywire Payments Limited 保管，如果这样，详细信息将以电子方式传递给我的银行/建房互助协会。',
  'confirmationPage.labels.termsAch': '\n     点击“确认”，即表示您确认您有适当权限，并特此授权飞汇代表指定接收人\n（“收款人”）从您的银行账户扣除因您使用收款人的服务\n和/或购买其产品产生的任何费用。并在必要时根据收款人的条款更正错误扣款，直至此\n此等授权被撤销。如果 ACH 交易因资金不足被拒绝，我了解我将被扣除\n账户余额不足 (NSF) 费用，并且飞汇可以自行决定尝试再次处理此类费用。\n     ',
  'confirmationPage.labels.termsAch2': '\n     根据收款人条款，如果您定期使用或购买收款人的其他产品和/或服务，即表示您授权\n飞汇代表收款人定期从您的银行账户扣款。对于上述授权扣款\n范围以外的付款，只有在通过您的账户、密码、代码或其他等效签名获得您的授权后才会扣除。\n\n     ',
  'confirmationPage.labels.termsAch3': '\n     您可以随时联系收款人撤销此类授权。收款人必须在下一次预定付款前至少 [10 个工作日]\n内收到您的撤销。\n    ',
  'confirmationPage.labels.print': '打印协议',
  'amountPanel.labels.amountFromLabel': '您将支付',
  'amountPanel.labels.surchargeFeeInfo': '已含卡费',
  'amountPanel.labels.serviceFeeInfo': '包含服务费',
  'amountPanel.labels.serviceFeePercentageInfo': '{{percentage}} 服务费（最低）{{minimumFee}} ）',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': '{{percentage}} 服务费',
  'amountPanel.labels.whyThisFee': '为什么会收取这笔费用？',
  'amountPanel.labels.currencyChangeWarning': '币种已更改，以便与您的银行卡币种相一致',
  'amountPanel.labels.amountToLabel': '“{{recipientName}}”将收到',
  'amountPanel.labels.editCurrencySelection': '编辑货币选择',
  'amountPanel.labels.discountApplied': '已应用 {{amount}} 折扣',
  'currencyInfoBanner.labels.currencyInfo': '我们将以 <b>{{code}} ({{symbol}})</b> 向您收取后续款项。',
  'currencyInfoBanner.error.offerNotFound': '没有可用的付款方式',
  'AX': '奥兰群岛',
  'AD': '安道尔',
  'BG': '保加利亚',
  'AT': '奥地利',
  'BE': '比利时',
  'HR': '克罗地亚',
  'CY': '塞浦路斯',
  'CZ': '捷克共和国',
  'DK': '丹麦',
  'EE': '爱沙尼亚',
  'FI': '芬兰',
  'FR': '法国',
  'GP': '瓜德罗普岛',
  'DE': '德国',
  'GR': '希腊',
  'HU': '匈牙利',
  'IS': '冰岛',
  'IE': '爱尔兰',
  'VA': '罗马教廷（梵蒂冈城国）',
  'IT': '意大利',
  'LI': '列支敦士登',
  'LT': '立陶宛',
  'LU': '卢森堡',
  'YT': '马约特岛',
  'MT': '马耳他',
  'MQ': '马提尼克',
  'ES': '西班牙',
  'NO': '挪威',
  'NL': '荷兰',
  'PL': '波兰',
  'PT': '葡萄牙',
  'SE': '瑞典',
  'RE': '留尼汪岛',
  'RO': '罗马尼亚',
  'CH': '瑞士',
  'BL': '圣巴泰勒米',
  'GB': '英国',
  'MC': '摩纳哥',
  'MF': '圣马丁（法属）',
  'PM': '圣皮埃尔和密克隆群岛',
  'SM': '圣马力诺',
  'SK': '斯洛伐克',
  'SI': '斯洛文尼亚',
  'GF': '法属圭亚那',
  'LV': '拉脱维亚',
  'CA': '加拿大',
  'US': '美国',
  'inlineDialogConfirmation.labels.title': '需要确认：取消流程',
  'inlineDialogConfirmation.labels.body': '是否确定要取消此流程？',
  'inlineDialogConfirmation.labels.closeButton': '否',
  'inlineDialogConfirmation.labels.confirmButton': '是',
  'priceBreakDown.price.toggle.button': '价格明细',
  'priceBreakDown.fx.toggle.button': '外汇明细',
  'priceBreakDown.fees': '费用',
  'priceBreakDown.service_fees': '服务费',
  'priceBreakDown.card_fees': '卡费用',
  'priceBreakDown.exchange.rate': '汇率',
  'priceBreakDown.markup.rate': 'ECB 加价率',
  'priceBreakDown.discount': '折扣',
  'priceBreakDown.discount.coupon': '折扣 ({{code}})',
  'priceBreakDown.original_amount': '原始金额',
  'priceBreakDown.total': '总计',
  'acceptProposedOfferBanner.textInfo': '此卡不符合条件。点击“接受”以继续到支持的付款方式，或 ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard': '此卡不符合条件。点击“接受”以继续到支持的付款方式。',
  'acceptProposedOfferBanner.link.option': '更改银行卡',
  'acceptProposedOfferBanner.labels.accept': '接受',
  'chooseCurrencyBanner.title': '选择币种',
  'chooseCurrencyBanner.message': '您的银行卡币种与账单所在国家/地区币种不同。请选择您希望用于本次交易的币种：',
  'banner.offer.validation.message': '您必须选择一项操作才能继续。',
  'instructions.offline.amount.label': '应付金额',
  'instructions.offline.reference.label': '付款编号 (Payment ID)',
  'instructions.offline.paymentId.label': '付款编号',
  'instructions.offline.paymentReferenceMissing': '付款编号不存在',
  'instructions.offline.missing.title': '无法生成付款说明',
  'instructions.offline.missing.message': '请重试。如果问题仍然存在，请尝试其他支付方式或联系您的银行。',
  'instructions.offline.title': '付款说明',
  'instructions.offline.understand': '我已了解，我需要从我的银行发起转账。<br />点击此处关闭。',
  'instructions.offline.download.button': '下载银行转账说明',
  'instructions.offline.howToBankTransfer': '如何进行银行转账？',
  'instructions.offline.howToBankTransfer.modal.title': '如何完成银行转账',
  'instructions.offline.howToBankTransfer.modal.intro': '以下是您可以用来完成银行转账的不同选项：',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': '网上银行/手机银行',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription': '如果您安装了银行提供的网上银行或手机应用程序，您就可以轻松登录账户并自行转账。',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': '亲自前往银行网点柜台',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription': '亲自前往您的当地银行网点，并向银行提供您的付款说明中所示的必要账户详情，以便进行转账。',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': '电话转账',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription': '您也可以致电银行，授权其代表您发起交易。',
  'instructions.offline.referenceWarning': '您必须包含此参考号，以便我们识别您的付款',
  'instructions.offline.dueDateLabel': '请在此时间之前进行资金转账：',
  'instructions.offline.processingTime': '飞汇收到资金：您发起转账后的 <strong>2–3 个工作日</strong>',
  'elementsInstructions.qr.description': '扫描二维码完成付款',
  'elementsInstructions.qr.payid.description': 'Open your banking app and send to the PayID below. This address is assigned exclusively to your account — payments are matched automatically.',
  'elementsInstructions.qr.scan': '或使用手机摄像头扫描',
  'elementsInstructions.qr.waitingForPayment': 'Awaiting payment completion',
  'elementsInstructions.externalAction.generic': '请完成付款以继续。',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone': 'M-Pesa 付款订单已发送至您的手机。\n请完成付款以继续。',
  'elementsInstructions.redirect.title': 'Complete your payment',
  'elementsInstructions.redirect.description': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again.',
  'elementsInstructions.redirect.button': 'Make your payment',
  'documentCollector.collapsibleTitle': '上传文件',
  'documentCollector.uploadingDocument': '正在上传文件',
  'documentCollector.deleteFile': '删除 {{fileName}}',
  'documentCollector.deletingFile': '正在删除 {{fileName}}',
  'documentCollector.moreInfoModal': '更多信息',
  'documentCollector.errorsModal': 'Document warnings',
  'documentCollector.documentList': '文件清单',
  'documentCollector.upload': '上传',
  'documentCollector.errorBlockLabel': 'Document warnings',
  'documentCollector.reUpload': '重新上传',
  'documentCollector.errorsFoundOne': '{{count}} Warning Found',
  'documentCollector.errorsFoundOther': '{{count}} Warnings Found',
  'documentCollector.validationNote': '<b>文件上传完成！</b>我们的自动扫描发现了潜在问题。如果您的文件包含所有必需信息，请忽略此警告。',
  'documentCollector.antivirus': '杀毒软件文件扫描',
  'documentCollector.antivirusStep': '杀毒文件扫描 1/2',
  'documentCollector.verifyingStep': '验证文件 2/2',
  'documentCollector.invalidFile': '检测到无效文件。文件可能已加密或受密码保护。请核实后重试。',
  'documentCollector.moreInfo': '更多信息',
  'documentCollector.required': '必填',
  'documentCollector.review': '评论',
  'documentCollector.acceptedFileTypes': '可接受的文件类型：<b>PDF</b>、<b>PNG</b>、<b>JPG</b>',
  'documentCollector.maxFileSize': '最大文件大小：<b>{{maxFileSize}} MB。</b>',
  'documentCollector.acceptedFileAndFileSize': '可接受的文件类型：<b>PDF</b>、<b>PNG</b>、<b>JPG</b>。最大文件大小：<b>{{maxFileSize}} MB。</b>',
  'documentCollector.docVerifyError.missingInfo': '请确保文件包含所有必要的信息。',
  'documentCollector.docVerifyError.documentTypeError': '这似乎不符合{{documentType}}的要求。请检查相关要求，并在必要时上传新文件。',
  'documentCollector.docVerifyError.documentIdentificationTypeError': '上传的文件看起来不像是 {{documentType}} 文件（您为这次付款选择的身份证明文件类型）。请检查并在必要时重新上传文件。',
  'documentCollector.docVerifyError.documentType.errorNote': '<b>注意</b>：提交不正确的文件可能会导致付款处理延迟。如果您的文件有效，请忽略此警告。',
  'documentCollector.duplicateFile': '检测到重复上传的文件。请为每项分别上传不同的文件。',
  'oneOff.savePaymentMethod.label': '保存此付款方式以备将来付款',
  'lrs.transaction.title': '交易',
  'lrs.transaction.date': '日期',
  'lrs.transaction.amount': '金额',
  'lrs.transaction.amountHint': '外币金额',
  'lrs.transaction.adBranch': 'AD 分行名称及地址',
  'lrs.transaction.add': '添加更多交易',
  'lrs.signatureModal.title': '签署文件',
  'lrs.signatureModal.tab.draw': '绘制签名',
  'lrs.signatureModal.tab.upload': '上传签名',
  'lrs.signatureModal.draw.text': '用您的鼠标或手指在下方提供的区域内签字，以接受该文件。',
  'lrs.signatureModal.legalAlert': '如果签名无效，则整个 LRS 流程将作废。请务必签署 <b>PAN 持有人</b>的签名。相关文件副本将被发送至所提供的付款人电子邮箱以供未来之需。可接受的文件类型：<b>PNG</b>、<b>JPG</b>。',
  'lrs.signatureModal.draw.clear': '清除',
  'lrs.signatureModal.upload.label': '上传您签名的图像版本',
  'lrs.signatureModal.upload.input': '上传签名',
  'lrs.signatureModal.upload.remove': '删除',
  'lrs.signatureModal.upload.hint': '可接受的文件类型： <b>PNG</b>、<b>JPG</b>。可接受的最大文件大小：<b>8MB</b>',
  'lrs.signatureModal.upload.typeError': '不支持该文件类型。请上传 PNG 或 JPG。',
  'lrs.signatureModal.upload.sizeError': '文件大小不能超过8MB',
  'lrs.signatureModal.upload.readError': '无法读取文件。请重试。',
  'lrs.signatureModal.confirm': '接受并提交',
  'lrs.signatureModal.previewError': '生成预览时出现了错误。请重试。',
  'lrs.signatureModal.uploadError': '提交时出现了错误。请重试。',
  'lrs.previewLink.label': '文件预览',
  'lrs.documents.continueButton': '继续提交 LRS 表格',
  'lrs.form.declaration': '根据自由化汇款计划 (LRS)，印度政府和印度央行 (RBI) 现在要求提供 LRS 申报表（完整标题“A2 暨 LRS 申报”）才能将资金转移到国外。必须提交 LRS 申报后才能发起银行转账，否则您的付款可能无法及时处理。有关如何完成这一步的更多详情，请点击<a href=\'https://help.flywire.com/hc/zh-cn/articles/360012963774\' target=\'_blank\'>此处</a>来了解。',
  'lrs.form.bankAccountAndStudentInfo.title': '银行账户和学生信息',
  'lrs.form.bankAccountAndStudentInfo.text': '请指明资金将从哪个银行账户转出。如果您已申请教育贷款，资金将从您的贷款账户中拨出，请提供银行账号。不接受来自 NRO/NRE 账户的资金转账。填写学号时可以使用以下任一标识：学号、申请号或参考编号。',
  'lrs.form.details.title': '当前财政年度的国际交易详情',
  'lrs.form.details.text': '请提供您在本财政年度（<b>{{startYear}} 4 月至 {{endYear}} 3 月</b>）进行的任何外币交易的详细信息。如无相关交易请留空。',
  'lrs.form.bankAccountNumber': '银行账号',
  'lrs.form.studentFullName': '学生全名',
  'lrs.form.studentId': '学号',
  'lrs.form.required': '必填',
  'lrs.form.signAndSubmit': '签署并提交 LRS 表格',
  'lrs.title': '上传文件并提交 LRS 表',
  'lrs.description': '完成此步骤后，您将获得银行转账说明。',
  'lrs.tabs.documents': '1. 上传文件',
  'lrs.tabs.form': '2. 提交 LRS 表格。',
  'recipientFields.requiredField': '(*) 必填项目',
  'paymentMethodSelector.loading': '正在加载付款方式…',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': '接受借记卡和信用卡',
  'paymentMethodSelector.cards.acceptsDebitOnly': '接受借记卡',
  'paymentMethodSelector.cards.acceptsCreditOnly': '接受信用卡',
  'paymentMethodSelector.cards.surchargeWarning': '根据卡片类型和发卡国家/地区，可能会收取附加费。',
  'paymentMethodSelector.subtitle.default': '用{{methodName}}支付',
  'paymentMethodSelector.subtitle.google_pay': '使用您保存的 Google Pay 钱包支付',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID 或 Face ID——仅限 Safari',
  'paymentMethodSelector.subtitle.paypal': '使用您的 PayPal 账户支付',
  'paymentMethodSelector.subtitle.wechat': '使用微信支付——适用于中国大陆',
  'paymentMethodSelector.subtitle.alipay': '使用支付宝支付',
  'paymentMethodSelector.subtitle.trustly': '开放银行付款'
} as const;
export { zhCN };
